<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { Development } from "@/services/westore/entities";
import moment from "moment";
import { Download } from "@/mixins/download";
import { channels } from "@/mixins/channels";
import WsTable from "../../../components/westoreTable/ws-table.vue";
import SkeletonLoader from "../../../components/skeletons/skeleton-loader.vue";
export default {
  mixins: [Download, channels],
  page: {
    title: "Development List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    WsTable,
    SkeletonLoader,
  },
  data() {
    return {
      title: "Development List",
      // filter: {
      //   sku: "",
      //   status: null,
      // },
      sortBy: "id",
      sortDesc: false,
      currentPage: 1,
      perPage: 20,
      paginateStart: 1,
      totalItems: 0,
      items: [],
      fields: [
        {
          key: "name",
          label: "TOKEN NAME",
          sortable: true,
        },
        {
          key: "created_at",
          label: this.$t("CREATED AT"),
          sortable: true,
        },
        {
          key: "permissions",
          label: "PERMISSIONS",
          sortable: true,
          tdClass: "permission-td",
        },
        {
          key: "revoke",
          label: "ACTIONS",
          sortable: true,
        },
      ],

      showContentLoader: true,
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.showContentLoader = true;

      let resp = await Development.getAll();

      this.items = resp.data;
      this.totalItems = resp.meta.total;
      this.showContentLoader = false;
    },

    convertDate: function (timestampValue) {
      return moment.unix(timestampValue).format("DD/MM/YYYY");
    },
    async revokeToken(id) {
      try {
        await Development.revoke(id);
        this.$toast.success("Token has been revoked successfully");
      } catch (error) {
        this.$toast.error("Something went wrong,please try again");
      }
    },
    async exportSheet(extension) {
      const data = await Development.blobResponse().export({ type: extension });

      const type = Development.getHeader("content-type");
      const filename = `development${new Date().getTime()}.${extension}`;
      this.download(data, type, filename);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title">
      <b-button
        type="submit"
        variant="primary"
        class="btn-block"
        size="md"
        @click="$router.push('/development/create')"
        ><i class="fa fa-plus mr-3"></i>Create New</b-button
      ></PageHeader
    >
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->

            <SkeletonLoader type="table" v-if="showContentLoader" />
            <div v-else>
              <WsTable
                :items="items"
                :totalItems="totalItems"
                :fields="fields"
                :paginateStart="paginateStart"
                :revokeToken="revokeToken"
              />

              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalItems"
                        :per-page="perPage"
                        :first-text="this.$t('First')"
                        :prev-text="this.$t('Prev')"
                        :next-text="this.$t('Next')"
                        :last-text="this.$t('Last')"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>
.p-item + .p-item:before {
  content: ", ";
}
</style>
